module.exports = __webpack_public_path__ + "img/CN.00d7b6d9.png";